import { getInstance } from './searchsync-create-instance';

function preFilterHits(preFilterItems, indexName) {
  window.addEventListener('searchsyncInstanceCreated', async () => {
    const search = getInstance(indexName)

    if (Array.isArray(preFilterItems)) {
      const filterString = preFilterItems.map(id => `NOT objectID:${id}`).join(' AND ');
      search.helper.setQueryParameter('filters', filterString).search();
    } else {
      console.error('preFilterItems are not an array');
    }
  })
}

export { preFilterHits }